import React from "react";
import { imageStyle } from "./imageStyle";
import PropTypes from "prop-types";
const Image = props => {
  const onClick = () => {
    props.onClick && props.onClick();
  }
  return (
    <>
      <img
        id={props.id}
        className={props.className}
        src={props.img_path}
        alt={props.img_alt}
        style={{ width: props.img_width, height: props.img_height }}
        onClick = {onClick}
      />

      <style jsx>{imageStyle}</style>
    </>
  );
};

export default Image;

Image.propTypes = {
  img_path: PropTypes.string,
  img_width: PropTypes.string,
  img_height: PropTypes.string,
  img_alt: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string
};

Image.defaultProps = {
  img_alt: "",
  className: "image"
};
